import { RESOURCES } from '../constants';

/**
 * Fetch a simple resource content, use it to fill search and autocomplete lists
 * @param {string} resource Resource name
 */
export const fetchSimpleResource = (resource, params = {}) => ({
  type: RESOURCES.FETCH_SIMPLE.REQUEST,
  resource,
  params,
});

/**
 * Fetch a resource content, use it to get data for tables
 * @param {string} resource Resource name
 */
export const fetchResource = (resource, params = {}) => ({
  type: RESOURCES.FETCH.REQUEST,
  resource,
  params,
});

/**
 * Remove a list of resources
 * @param {string} resource Resource name
 * @param {array} ids list of ids to be removed
 */
export const removeResource = (resource, ids = []) => ({
  type: RESOURCES.REMOVE.REQUEST,
  resource,
  ids,
});

/**
 * Remove all resources from specific type
 * @param {string} resource Resource name
 * @param {typeId} ids type_id
 */
export const removeAllResources = (resource, typeId) => ({
  type: RESOURCES.REMOVE_ALL.REQUEST,
  resource,
  typeId,
});

/**
 * Post a new resource
 * @param {string} resource 'Resource name'
 * @param {object} data FORM data
 * @param {object} options Option params (path)
 */
export const saveResource = (resource, data, options) => ({
  type: RESOURCES.SAVE.REQUEST,
  resource,
  data,
  options,
});

/**
 * Refetch a resource content
 * @param {string} resource Resource name
 */
export const refetchResource = (resource, params = {}) => ({
  type: RESOURCES.REFETCH.REQUEST,
  resource,
  params,
});

/**
 * Clear filters
 * @param {string} resource Resource name
 * @param {Array} filters list of filters names
 */
export const clearFilters = (resource, filters = []) => ({
  type: RESOURCES.FILTERS.CLEAR,
  resource,
  filters,
});

export const updateResourceData = (resource, task) => ({
  type: RESOURCES.UPDATE_DATA,
  resource,
  task,
});

export const addResourceData = (resource, task) => ({
  type: RESOURCES.ADD_DATA,
  resource,
  task,
});

export const removeResourceData = (resource, id) => ({
  type: RESOURCES.REMOVE_DATA,
  resource,
  id,
});

/**
 * Get task summary
 * @param {string} resource Resource name
 * @param {string} resourceTypeId Task type ID
 */
export const getTasksSummary = (resource, resourceTypeId) => ({
  type: RESOURCES.TASKS_SUMMARY.REQUEST,
  resource,
  resourceTypeId,
});

export const getResourceCSV = (resource, resourceTypeId, params = {}) => ({
  type: RESOURCES.TASKS_CSV.REQUEST,
  resource,
  resourceTypeId,
  params,
});



// WEBPACK FOOTER //
// ./src/store/actions/resources.actions.js